import React from 'react';
import { Alert, Button, FormControl, Well } from 'react-bootstrap';

interface IProps {
    startDate: string,
    endDate: string,
    showDefinitions: boolean,
    showSummary: boolean,
    showDateWarning: boolean,
    onSearch: () => void,
    onSearchChange: (name: string, value: string) => void,
    onToggleDefinitions: () => void,
    onToggleSummary: () => void,
    onExport: () => void
}

const Filter: React.FC<IProps> = ({
    startDate,
    endDate,
    showDefinitions,
    showSummary,
    showDateWarning,
    onSearch,
    onSearchChange,
    onToggleDefinitions,
    onToggleSummary,
    onExport
}) => {
    const handleFieldChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        onSearchChange(name, value);
    };

    return (
        <>
            {showDateWarning && (
                <div style={{ backgroundColor: '#843534', color: 'white', padding: '2px 5px', borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
                    Please make sure that the start and end dates are valid...
                </div>
            )}

            <Well bsSize='sm'>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                            <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                            <div className={showDateWarning ? 'has-error' : null}>
                                <FormControl
                                    type='date'
                                    name='startDate'
                                    value={startDate}
                                    onChange={handleFieldChange}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                            <div style={{ marginRight: 5 }}>End Date:</div>
                            <div className={showDateWarning ? 'has-error' : null}>
                                <FormControl
                                    type='date'
                                    name='endDate'
                                    value={endDate}
                                    onChange={handleFieldChange}
                                />
                            </div>
                        </div>

                        <div>
                            <Button bsStyle='primary' onClick={onSearch}>Search</Button>
                        </div>
                    </div>

                    <div>
                        <Button onClick={onToggleDefinitions}>{showDefinitions ? 'Show Definitions' : 'Hide Definitions'}</Button>&nbsp;
                        <Button onClick={onToggleSummary}>{showSummary ? 'Show Summary' : 'Hide Summary'}</Button>
                    </div>

                    <div>
                        <Button onClick={onExport}>Export CSV</Button>
                    </div>
                </div>
            </Well>
        </>
    );
}

export default Filter;